// extracted by mini-css-extract-plugin
module.exports = {"root":"AiTestPage_root__38__-","json":"AiTestPage_json__36gcB"};